<template>
    <div>
        <Panel
            :title="$t('Manage CLI Groups')"
            :add-button="$store.hasRight('ADD_CLI_GROUPS') ? $t('New Origination Group') : ''"
            :delete-button="selected.length > 0"
            :help-text="$t('DESC_MANAGE_CLI_GROUPS')"
            :total-rows="items.length"
            :page="page"
            @delete="handleDelete"
            @input="openForm(-1)"
            @change="setPage"
        >
            <table id="cligroups_table" class="cic-table">
                <thead>
                    <tr>
                        <th class="td-checkbox" style="width: 25px; padding: 0 5px"></th>
                        <th class="td-checkbox" style="width: 25px; padding: 0 5px"></th>
                        <th>{{ $t('Group Name') }}</th>
                        <th>{{ $t('Type') }}</th>
                        <th>{{ $t('Description') }}</th>
                        <th v-if="$store.hasRight('DELETE_CLI_GROUPS')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(group, groupIndex) in groups">
                        <td style="padding: 0 5px">
                            <IconButton
                                v-if="groupIndex < groups.length - 1"
                                icon="down-icon"
                                class="el-icon-arrow-down"
                                @click="move(group.groupId, false)"
                            />
                        </td>
                        <td style="padding: 0 5px">
                            <IconButton
                                v-if="groupIndex > 0"
                                icon="up-icon"
                                class="el-icon-arrow-up"
                                @click="move(group.groupId, true)"
                            />
                        </td>
                        <td class="primary" @click="(evt) => handleOpen(group.groupId, evt)">
                            {{ group.name }}
                        </td>
                        <td @click="(evt) => handleOpen(group.groupId, evt)">{{ group.type }}</td>
                        <td @click="(evt) => handleOpen(group.groupId, evt)">{{ group.description }}</td>
                        <td v-if="$store.hasRight('DELETE_CLI_GROUPS')">
                            <cic-checkbox
                                :value="selected.indexOf(group.groupId) !== -1"
                                @click="handleSelected(group.groupId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditOriginationGroup
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @change="updateFieldValue"
            @input="saveGroup"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import IconButton from '@/components/controls/IconButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditOriginationGroup from './EditOriginationGroup';

    export default {
        name: 'OriginationGroups',
        components: {
            CicCheckbox,
            EditOriginationGroup,
            IconButton,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                page: 1,
                selected: [],
            };
        },
        computed: {
            groups() {
                return this.items.slice((this.page - 1) * 20, this.page * 20);
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('originationgroups/delete', { groupIds: this.selected }, () => {
                    this.page = 1;
                    this.loadTable();
                });
            },

            loadTable() {
                this.item = null;
                this.selected = [];
                load('originationgroups/get', {}, (response) => {
                    this.items = response.groups;
                });
            },

            move(groupId, up) {
                save('originationgroups/prioritise', { groupId, up: up ? 1 : 0 }, () => {
                    this.loadTable();
                });
            },

            openForm(groupId) {
                this.item = null;
                if (groupId > 0) {
                    load('originationgroup/get', { groupId }, (response) => {
                        this.item = response.group;
                    });
                } else {
                    this.item = {
                        groupId: null,
                        name: '',
                        description: null,
                        type: 'CLI',
                        members: [],
                    };
                }
            },

            saveGroup() {
                if (this.item.name.trim() === '') {
                    alert(this.$t('Group Name is a required field'));
                    return;
                }

                const params = {
                    groupId: this.item.groupId,
                    name: this.item.name,
                    type: this.item.type,
                    description: this.item.description,
                    members: JSON.stringify(this.item.members),
                };

                save('originationgroup/update', params, () => {
                    this.loadTable();
                });
            },
        },
    };
</script>
